<template>
  <div v-show="this.showLeftMenu"
       v-loading="loading" element-loading-text="菜单加载中，请稍候..."
       class="panel" >
    <div ref="leftMenuHead" class="panel-head">
      <div :class="{'tree-search-focus': treeSearchInputFocus}" class="tree-search">
        <span class="tree-search-ico">
          <i class="mng icon-zoom-stroke"></i>
        </span>
        <input
          v-model.trim="menuSearchInputVal"
          @focus="handleTreeSearchInputFocusAndBlur(true)"
          @blur="handleTreeSearchInputFocusAndBlur(false)"
          class="tree-search-input" placeholder="搜索菜单">
      </div>
      <div @click="handleTreeExpend" class="tree-control">
        <el-tooltip effect="dark" :content="!treeAllNodeExpend?'全部展开':'全部收起'" placement="top">
          <a href="javascript:" class="tree-control-btn">
            <i :class="[{'icon-tree-unfold': !treeAllNodeExpend}, {'icon-tree-fold': treeAllNodeExpend}]" class="mng"></i>
          </a>
        </el-tooltip>
      </div>
    </div>
    <el-scrollbar class="whaty-scroll" ref="leftMenuScrollBar" :style="{'height': treeContainerHeight + 16+ 'px'}">
      <ul style="overflow-x: hidden;">
        <li class="treeRow" v-for="node in treeData" v-show="node.show === undefined || node.show">
          <div class="treeNode treePrimary-node"
               :class="[{treeOpen: node.open}, {treeCur: (currentNodeId && (node.id === currentNodeId || node.routerName === currentNodeId))}]"
               @click="handleTreeNodeClick(node)">
            <div class="treeNodeIn">
              <span class="treeNode-ico"><i :class="['mng', node.icon || 'icon-tree-files-stroke']"></i></span>
              <a href="javascript:" class="treeNode-txt">{{ node.name }}</a>
              <span class="treeNode-fold" v-if="node.children && node.children.length > 0"><i class="mng icon-lineArrR-stroke"></i></span>
            </div>
          </div>
          <el-collapse-transition>
            <div class="treeContent treePrimary-con" v-show="node.open" v-if="node.children && node.children.length > 0">
              <ul>
                <sub-tree-row
                  v-for="(item, i) in node.children"
                  v-show="item.show === undefined || item.show"
                  :key="i"
                  :data="item"
                  :level="1"
                  @node-click="handleTreeNodeClick"
                ></sub-tree-row>
              </ul>
            </div>
          </el-collapse-transition>
        </li>
      </ul>
    </el-scrollbar>
    <!----------- tree end ---------->
  </div>
</template>
<script>
  import {STORE_APP_MUTATION_TYPES} from '../../libs/constants'
  import SubTreeRow from './sub-tree-row.vue'
  import util from '../../libs/util'

  let _ = require('lodash')

  export default {
    components: {SubTreeRow},
    name: 'left-menu',
    data() {
      return {
        treeData: [],
        loading: true,
        treeContainerHeight: 200, // 菜单区域高度
        menuSearchInputVal: '', // 菜单搜索框输入内容
        treeSearchInputFocus: false, // 菜单搜索框获取焦点标志
        treeAllNodeExpend: false // 菜单全部展开标志
      }
    },
    computed: {
      currentNodeId: function () {
        return this.$store.state.app.currentLeftMenuId
      },
      showLeftMenu: function () {
        return this.$store.state.app.showLeftMenu
      }
    },
    created() {
    },
    mounted() {
      this.loadTreeData()
      this.treeContainerAutoHeight()
    },
    methods: {
      loadTreeData() { // 加载菜单数据
        this.$store.dispatch('GetMenuTree').then(data => { // 拉取权限
          this.treeData = data
          this.loading = false
          // 判断是否有默认menu，有则打开
          let defaultMenu = this.$store.state.app.defaultMenu
          if (defaultMenu.id) {
            this.handleTreeNodeClick(defaultMenu)
          }
        }).catch((e) => {
          console.error(e)
          this.$notify.error({title: '错误', message: '菜单加载失败！'})
          this.loading = false
        })
      },
      handleTreeNodeClick(node) { // 菜单点击
        // 更新激活的左侧菜单
        this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_LEFT_MENU, {id: node.routerName || node.id})
        if (node.children && node.children.length > 0) { // 如果是目录,则打开目录
          this.$set(node, 'open', !node.open)
        } else { // 如果是叶子节点,则执行以下逻辑
          // 判断菜单是否已经打开过,如果已经打开过则切换到对应的标签即可,如果没有打开过则新打开菜单
          let routerName = node.routerName || node.id
          let isOpened = false
          let toRouter = {name: routerName}
          let currentTab = {id: routerName, routers: []}
          let topTabList = this.$store.state.app.topTabList
          for (let i = 0; i < topTabList.length; i++) {
            if (topTabList[i].id === routerName) {
              isOpened = true
              toRouter = util.getDestRouter(topTabList[i])
              currentTab = topTabList[i]
              break
            }
          }
          if (!isOpened) {
            // 新增一个顶部标签
            this.$store.commit(STORE_APP_MUTATION_TYPES.ADD_ONE_TOP_TAB, {id: routerName, name: node.name})
          }
          // 更新currentPage
          this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE, currentTab)
          // 切换路由
          this.$router.push(toRouter)
        }
      },
      treeContainerAutoHeight() { // tree container auto height
        if (this.$el && this.$refs.leftMenuHead) {
          let oldHeight = this.treeContainerHeight
          this.treeContainerHeight = this.$el.offsetHeight - this.$refs.leftMenuHead.offsetHeight
          // 当容器的高度变化时更新滚动条状态(因为el-scrollbar自身不会更新)
          if (oldHeight !== this.treeContainerHeight) {
            this.$refs.leftMenuScrollBar.update()
          }
          setTimeout(() => {
            this.treeContainerAutoHeight()
          }, 200)
        }
      },
      handleTreeSearchInputFocusAndBlur(focus) { // 菜单搜索框获得焦点时增加样式
        this.treeSearchInputFocus = focus
      },
      searchMenu: _.debounce( // 菜单搜索
        function () {
          for (let i = 0; i < this.treeData.length; i++) {
            this.searchMenuNode(this.treeData[i])
          }
        },
        500 // 用户输入结束判定延迟时间
      ),
      searchMenuNode(node) { // 检索菜单，叶子节点有匹配时，父节点才会显示
        let show = false
        if (node.children && node.children.length > 0) {
          for (let i = 0; i < node.children.length; i++) {
            if (this.searchMenuNode(node.children[i])) {
              show = true
            }
          }
        } else {
          show = node.name.indexOf(this.menuSearchInputVal) !== -1
        }
        this.$set(node, 'show', show)
        if (this.menuSearchInputVal) {
          this.$nextTick(_ => {
            this.$set(node, 'open', show)
          })
        }
        return show
      },
      expendTreeNode(node) { // 展开/折叠 菜单
        if (node.children && node.children.length > 0) {
          this.$set(node, 'open', !this.treeAllNodeExpend)
          for (let i = 0; i < node.children.length; i++) {
            this.expendTreeNode(node.children[i])
          }
        }
      },
      handleTreeExpend() { // 展开/折叠 菜单
        for (let i = 0; i < this.treeData.length; i++) {
          this.expendTreeNode(this.treeData[i])
        }
        this.treeAllNodeExpend = !this.treeAllNodeExpend
      }
    },
    watch: {
      menuSearchInputVal: function () { // 菜单搜索
        this.searchMenu()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/left-menu/left-menu.vue